var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CEPs',{attrs:{"info":_vm.filter.info,"filterName":_vm.filter.title,"selectedCEPs":_vm.selectedCEPs},on:{"setSelectedFilterCep":_vm.setSelectedFilterCep}})}
var staticRenderFns = []

export { render, staticRenderFns }